import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IBaseMccField {
	changeBaseMcc: (value: Nullable<number>) => void;
}

const BaseMccField: React.FC<IBaseMccField> = ({ changeBaseMcc }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterBaseMcc') }], [t]);

	const handleChange = useCallback(
		(value: Nullable<number>) => {
			changeBaseMcc(value);
		},
		[changeBaseMcc],
	);

	return (
		<FormInput
			testId="BaseMccField"
			type="number"
			min={1000}
			max={9999}
			name="baseMcc"
			label="baseMccLabel"
			onChangeNumber={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(BaseMccField);
